<script setup lang="ts">
    import { IChatMessage } from '@/js/services/api/chat/chat';

    defineProps<{
        message: IChatMessage;
    }>();
</script>

<template>
    <template v-for="(item, index) of message.messageRows" :key="index">
        {{ item }}
        <br />
    </template>
</template>
